export default {
    item: {
        username: '用户名',
        password: '密码',
        email: '邮箱',
    },
    userForm: {
        title: '角色咨询',
        id: '请输入角色Id',
        idEmptyRemind: '角色Id不能为空',
        idErrorRemind: '角色Id必须为数字值',
        email: '请输入电子邮箱',
        emailEmptyRemind: '请输入邮箱地址',
        emailErrorRemind: '请输入正确的邮箱地址',
        required: '必填：请填写个人电子邮箱(邮箱名称不小于4位)，接受本次订单的收据.',
    },
    confirm: '确认',
    cancel: "取消",
    shop: {
        name: '商品',
        detail: '商品详情',
        little0: '礼包',
        little1: '代金券',
    },
    info: '详情',
    order: {
        summary: '订单摘要',
        id: '角色ID',
        nikeName: '角色昵称',
        email: '电子邮箱',
        productName: '商品名称',
        paymentAmount: '支付金额',
        payWarn: "温馨提示：为了缩短商品到账延迟，支付成功后建议",
        payObvious: "重新启动游戏客户端软件",
    },
    jsHint: {
        role:{
            notExist: "查无该角色信息！！！",
            infoError: "角色信息输入错误！！！",
            input: "请先输入角色信息！！！",
        },
        shop: {
            choose: "请选择商品！！！",
            limit: "该商品已达到购买上限，请重新选择！！！",
        },
        order: {
            fail: "创建订单失败，请联系客服！！！" ,
        },
    },

    channel: {
        title: "支付渠道",
        EN: "英文地区",
        TW: "繁体中文地区",
        CN: "简体中文地区",
        SCN: "简体中文(东南亚地区)",
        warn: "请选择所在区域便于我们提供支付方式。",
    },


}